import { useState } from 'react';
import { createPortal } from 'react-dom';
import { BoltIcon } from '@heroicons/react/24/outline';
import { PatientAddVasModal } from './PatientAddVasModal';
import { ADD_VA_BUTTON } from './virtualAppointmentActionStyles';

// Portalled: the button sits inside a sidebar tab, whose ancestors must not clip or stack the modal.
export function AddVasButton({ patientId }: { patientId: string }) {
    const [adding, setAdding] = useState(false);
    return (
        <>
            <button type="button" onClick={() => setAdding(true)} className={ADD_VA_BUTTON}>
                <BoltIcon aria-hidden="true" className="h-3.5 w-3.5" />
                Add VAs
            </button>
            {adding &&
                createPortal(
                    <PatientAddVasModal patientId={patientId} onClose={() => setAdding(false)} />,
                    document.body
                )}
        </>
    );
}
